import React from 'react';

/**
 * SettingsCompany - Company information tab component
 * Contains: company name, address, phone form
 */
const SettingsCompany = ({
  companyInfo,
  setCompanyInfo,
  onSave,
  loading
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(companyInfo);
  };

  return (
    <div className="settings-section compact">
      <div className="section-header">
        <h2>Company Information</h2>
      </div>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Company Name</label>
          <input
            type="text"
            value={companyInfo.name}
            onChange={(e) => setCompanyInfo({ ...companyInfo, name: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <label>Address</label>
          <textarea
            value={companyInfo.address}
            onChange={(e) => setCompanyInfo({ ...companyInfo, address: e.target.value })}
            rows="2"
          />
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <input
            type="tel"
            value={companyInfo.phone}
            onChange={(e) => setCompanyInfo({ ...companyInfo, phone: e.target.value })}
          />
        </div>

        <button type="submit" className="save-btn" disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
      </form>
    </div>
  );
};

export default SettingsCompany;
